export default "__VITE_ASSET__PwxtYcrj__"